import { en, type Catalog, type MessageKey } from './messages/en';
import { id } from './messages/id';
import type { Locale } from './locales';

export const catalogs: Record<Locale, Catalog> = { en, id };

export type MessageParams = Readonly<Record<string, string | number>>;
export type Translate = (key: MessageKey, params?: MessageParams) => string;

const PLACEHOLDER = /\{(\w+)\}/g;

/** Interpolate `{name}` placeholders. Unknown placeholders are left visible on purpose. */
export function interpolate(template: string, params?: MessageParams): string {
  if (!params) return template;
  return template.replace(PLACEHOLDER, (match, name: string) =>
    Object.hasOwn(params, name) ? String(params[name]) : match,
  );
}

export function placeholders(template: string): string[] {
  return [...template.matchAll(PLACEHOLDER)].map((m) => m[1] ?? '').sort();
}

export function createTranslator(locale: Locale): Translate {
  const catalog = catalogs[locale];
  return (key, params) => interpolate(catalog[key] ?? en[key] ?? key, params);
}
